import React from 'react';
import PropTypes from 'prop-types';
import { PrinterIcon } from '@glu/icons-react';

/*
 * @description: Need to forward ref because React-to-Print
 * sets it internally and we get an error otherwise
 * We have to "use" the ref (_) or else there is a lint error.
 */
/* eslint-disable no-unused-vars */
const GetTrigger = React.forwardRef(({ iconProps, onClick, ...rest }, _) => (
  <PrinterIcon onClick={onClick} {...rest} {...iconProps} actionable />
));

GetTrigger.defaultProps = {
  onClick: undefined,
  iconProps: undefined
};

GetTrigger.propTypes = {
  onClick: PropTypes.func,
  iconProps: PropTypes.shape({})
};

export default GetTrigger;
